module.exports = __webpack_public_path__ + "static/media/nft3MOBILE.6d5d4a86.jpg";